/**
 * USE-RISK-FILTERS-SELECTION
 * Selection des lieux et fonctions dans les panneaux de filtres des risques (familles, mesures).
 */
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import populationStore from "@/entities/population/model/population.store"
import siteStore from "@/entities/site/model/site.store"

export default function useRiskFiltersSelection() {
  const dispatch = useAppDispatch()
  const selectedSiteIds = useAppSelector(siteStore.selectors.selected)
  const selectedPopulationIds = useAppSelector(populationStore.selectors.selected)

  function addPopulation(populationId: string) {
    if (!selectedPopulationIds.includes(populationId)) {
      dispatch(populationStore.actions.select(selectedPopulationIds.concat(populationId)))
    }
  }

  function replaceWithSite() {
    dispatch(populationStore.actions.select([]))
    dispatch(physicalRiskStore.actions.select([]))
  }

  function removeSite(siteId: string) {
    dispatch(siteStore.actions.select(selectedSiteIds.filter((id) => id !== siteId)))
  }

  function replaceWithPopulation(populationId: string) {
    if (selectedPopulationIds.includes(populationId)) {
      dispatch(populationStore.actions.select([]))
      return
    }

    dispatch(siteStore.actions.select([]))
    dispatch(physicalRiskStore.actions.select([]))
    dispatch(populationStore.actions.select([populationId]))
  }

  function removePopulation(populationId: string) {
    dispatch(populationStore.actions.select(selectedPopulationIds.filter((id) => id !== populationId)))
  }

  return { addPopulation, replaceWithSite, removeSite, replaceWithPopulation, removePopulation }
}
